module.exports = __webpack_public_path__ + "img/21f5bd7.png";